import { useCallback } from 'react'
import { useBulkActionContext } from '@user/components/xGrid'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { updateLoadingState } from '@sales-center/common'
import { BulkReopenFormModel, SubmitCallback } from '../typings'

export const useFormActions = (submitCallback: SubmitCallback) => {
  const appDispatch = useAppDispatch()
  const { selectedRows, dispatch } = useBulkActionContext()

  const onSubmit = useCallback(
    async ({ expectedClosingDate, owner }: BulkReopenFormModel) => {
      try {
        appDispatch(updateLoadingState('visible'))
        await submitCallback({
          expectedClosingDate,
          ids: selectedRows.map((id) => Number(id)),
          owner: owner?.id || null,
        })
        dispatch({ type: 'setActive' })
      } finally {
        appDispatch(updateLoadingState('hidden'))
      }
    },
    [appDispatch, dispatch, submitCallback, selectedRows],
  )

  return onSubmit
}
